import { get } from "lodash";
import { MutableRefObject } from "react";

import { AxiosError } from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { URLSearchParams } from "url";

import { ReactComponent as Delete } from "../../assets/icons/ToastDelete.svg";
import { ReactComponent as ErrorI } from "../../assets/icons/ToastError.svg";
import { ReactComponent as Success } from "../../assets/icons/ToastSuccess.svg";
import { theme } from "../../theme";
import sharedConstants from "../constants";
import { CatalogType, OrderServiceTypes, Service } from "../enums";
import { RefetchRefCurrent } from "../interface";
import { strings } from "./types";

interface Error {
  message: string;
  status: number;
}

interface Error {
  message: string;
  status: number;
}
export const isNotEmpty = (list: any[] | any) => !!list && list.length > 0;

export const createError = (message: string, status: number): Error => ({
  message,
  status,
});
export const isNumeric = (num: string) => {
  return !Number.isNaN(num);
};

export const removeToken = (title?: string) => {
  localStorage.removeItem(title || "undefined");
};
export const setToken = (title: string, val: string) => {
  localStorage.setItem(title || "undefined", val);
};
export const setAccountInfo = (val: string) => {
  localStorage.setItem("repairshop_user", val);
};
// "초기 비밀번호 설정시 또는 비밀번호 초기화시 또는 비밀번호 변경일이 90일 지났을 때 노출되는 팝업
// - 설정할 비밀번호 입력

// 비밀번호 설정 규칙
// - 영문, 숫자, 특수문자 2가지 조합 후 10자리 ~ 20자리 이내
// - 패스워드 변경 주기 3개월 (90일)
// - 키보드 순서로 3번 이상 연속된 문자 입력 불가
// - 동일한 글자가 3번이상 중복 불가"

export const validatePhone = (e?: string, target?: string) => {
  if (e === undefined) return false;
  const phoneRegex = /^01([0|1|6|7|8|9])?([0-9]{4})?([0-9]{4})$/;
  return phoneRegex.test(e);
};

export const handleError = (e: AxiosError | unknown): { error: Error } => {
  const status: number = get(e, "response.status");
  const message: string[] | string = get(e, "response.data.message");
  const isNetworkError = get(e, "message") === "Network Error";
  let errorMessage: string;

  if (isNotEmpty(message)) {
    if (status === 404) errorMessage = "검색결과가 없습니다!";
    if (typeof message === "string") errorMessage = message;
    else errorMessage = message.join(" | ");
  } else if (isNetworkError) {
    errorMessage = "네트워크 연결 상태를 확인해주세요.";
  } else {
    errorMessage = "Unexpected Error";
  }

  return {
    error: createError(errorMessage, status),
  };
};
export const validateEmail = (e?: string) => {
  if (e === undefined) return false;
  const emailRegex =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
  return emailRegex.test(e);
};
export const numberWithCommas = (x: number | string): string => {
  const regex = /\B(?=(\d{3})+(?!\d))/g;
  if (x) {
    if (typeof x === "string") {
      return x.replace(regex, ",");
    }
    return x.toString().replace(regex, ",");
  }
  return "0";
};
export const getModalFetchFunction = (
  ref: MutableRefObject<RefetchRefCurrent | null>
) => {
  if (ref?.current?.reload && ref?.current.reset)
    return {
      reload: ref.current?.reload,
      reset: ref.current?.reset,
    };
  return {
    reload: () => {},
    reset: () => {},
  };
};
export const getCatalogGroupType = (key: string) => {
  if (key.includes("타이어")) {
    return CatalogType.TIRE;
  }
  if (key.includes("배터리")) {
    return CatalogType.BAT;
  }
  if (key.includes("엔진오일")) {
    return CatalogType.ETC;
  }

  return CatalogType.ETC;
};
export const getNowDate = () => {
  const now = moment().hours(0).milliseconds(0).minutes(0).seconds(0);
  return now;
};
export const getServiceKey = (title?: string) => {
  switch (title) {
    case sharedConstants.text.TEXT_BOS:
      return Service.BOS_WEB;

    case sharedConstants.text.TEXT_CUSTOMER_APP:
      return Service.CUSTOMER_APP;
    case sharedConstants.text.TEXT_REPAIRSHOP:
      return Service.REPAIR_SHOP_WEB;
    case "전체":
    case "":
    default:
      return Service.ALL;
  }
};

export const getServiceKoreaName = (key: Service) => {
  switch (key) {
    case Service.BOS_WEB:
      return sharedConstants.text.TEXT_BOS;
    case Service.CUSTOMER_APP:
      return sharedConstants.text.TEXT_CUSTOMER_APP;
    case Service.REPAIR_SHOP_WEB:
      return sharedConstants.text.TEXT_REPAIRSHOP;
    default:
      return key;
  }
};
export const alertError = (content: string, onClose?: any) => {
  if (toast.isActive(content) === false)
    if (content.length > 0)
      toast.error(content, {
        icon: <ErrorI />,
        onClose: () => {
          if (onClose) onClose();
        },
        toastId: content,
        autoClose: 2000,
        style: {
          background: "#FFFFFF",
          /* Alert/Admin_purple */
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: "14px",
          lineHeight: "24px",

          border: "1px solid #E60000",
          boxSizing: "border-box",
          /* DP/2dp */
          color: "#E60000",

          boxShadow: "0px 2px 10px rgba(25, 25, 30, 0.1)",
          borderRadius: "8px",
        },
      });
};

export const alertSuccess = (content: string, onClose?: any) => {
  toast.success(content, {
    icon: <Success />,
    onClose,
    style: {
      background: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "24px",
      border: `1px solid #${theme.colors.mainPrimary3}`,
      boxSizing: "border-box",
      boxShadow: "0px 2px 10px rgba(25, 25, 30, 0.1)",
      borderRadius: "8px",
    },
  });
};

export const alertDelete = (message?: string, onClose?: any) => {
  toast.warn(message || strings.SUCCESS_REMOVE, {
    icon: <Delete />,
    onClose,
    style: {
      background: "#FFFFFF",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "24px",
      border: `1px solid ${theme.colors.red3}`,
      boxSizing: "border-box",
      boxShadow: "0px 2px 10px rgba(25, 25, 30, 0.1)",
      borderRadius: "8px",
      color: theme.colors.red3,
    },
  });
};
export const inputMoneyFormat = (obj: string) => {
  if (obj === "0") {
    return "";
  }

  return comma(obj) || "";
};

export const comma = (str: string) => {
  str = String(str);
  return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
};

export const uncomma = (str?: string | number) => {
  str = String(str);
  return str.replace(/[^\d]+/g, "");
};
export const getToken = (title: string) => {
  return localStorage.getItem(title);
};
export const removeLocalStorageItem = (title: string) => {
  localStorage.removeItem(title);
};
export const addLocalStorageItem = (title: string, val: any) => {
  localStorage.setItem(title, val);
};
export const setInitialFilter = (
  searchParams: URLSearchParams,
  filter: any
) => {
  const keys = Object.keys(filter);
  const newFilter: typeof filter = {};
  for (let i = 0; i < keys.length; i += 1) {
    switch (keys[i]) {
      case "startedAt":
        newFilter[keys[i]] =
          searchParams.get("starteAt") === "undefined" ||
          searchParams.get("startedAt") === null
            ? undefined
            : searchParams.get("startedAt");
        break;
      case "endedAt":
        newFilter[keys[i]] =
          searchParams.get("endedAt") === "undefined" ||
          searchParams.get("endedAt") === null
            ? undefined
            : searchParams.get("endedAt");
        break;
      case "dateRange":
        newFilter[keys[i]] =
          searchParams.get("startedAt") === null ||
          searchParams.get("startedAt") === "undefined" ||
          searchParams.get("endeddAt") === "undefined" ||
          searchParams.get("endedAt") === null
            ? null
            : [
                moment(searchParams.get("startedAt")),
                moment(searchParams.get("endedAt")),
              ];
        break;
      case "signupRange":
        newFilter[keys[i]] =
          searchParams.get("signupStartedAt") === null ||
          searchParams.get("signupStartedAt") === "undefined" ||
          searchParams.get("signupEndedAt") === "undefined" ||
          searchParams.get("signupEndedAt") === null
            ? undefined
            : [
                moment(searchParams.get("signupStartedAt")),
                moment(searchParams.get("signupEndedAt")),
              ];
        break;
      case "applyRange":
        newFilter.applyRange =
          searchParams.get("createStartedAt") === null ||
          searchParams.get("createStartedAt") === "undefined" ||
          searchParams.get("createEndedAt") === "undefined" ||
          searchParams.get("createEndedAt") === null
            ? undefined
            : [
                moment(searchParams.get("createStartedAt")),
                moment(searchParams.get("createEndedAt")),
              ];
        break;
      case "createRange":
        newFilter.createRange =
          searchParams.get("createStartedAt") === null ||
          searchParams.get("createStartedAt") === "undefined" ||
          searchParams.get("createEndeddAt") === "undefined" ||
          searchParams.get("createEndeddAt") === null
            ? undefined
            : [
                moment(searchParams.get("createStartedAt")),
                moment(searchParams.get("createEndeddAt")),
              ];
        break;
      case "signupStartedAt":
      case "signupEndedAt":
      case "createStartedAt":
      case "createEndedAt":
        newFilter[keys[i]] =
          searchParams.get(keys[i]) === null
            ? undefined
            : moment(searchParams.get(keys[i])).toDate();
        break;
      case "status":
        newFilter[keys[i]] =
          searchParams.get(keys[i]) === null
            ? undefined
            : searchParams.get(keys[i]);
        break;
      default:
        newFilter[keys[i]] =
          searchParams.get(keys[i]) === null
            ? undefined
            : searchParams.get(keys[i]);
    }
  }

  return newFilter;
};
export const validatePass = (pass: string) => {
  const messages = [];
  const checkedPw = checkPw(pass);
  // if (checkDuplication(pass))
  //   messages.push("동일한 글자가 3번이상 중복될 수 없습니다.");
  for (let i = 0; i < checkedPw.length; i += 1) {
    messages.push(checkedPw[i]);
  }
  // if (keyboardCheck(pass) === true)
  // messages.push("연속된 문자를 입력할 수 없습니다.");
  return messages;
};

export const keyboardCheck = (pass: string) => {
  const word = ["qwertyuiop", "asdfghjkl", "zxcvbnm"];
  const specialWord = ["!@#$%^&*()"];
  const wordAll = [
    "1234567890",
    ...specialWord,
    ...word,
    ...word.map((v) => v.toUpperCase()),
  ];
  const reverseWord = [...wordAll.map((v) => v.split("").reverse().join(""))];
  const keyboard = [...wordAll, ...reverseWord];
  for (let i = 0; i < pass.length - 2; i += 1) {
    const sliceValue = pass.substring(i, i + 3);

    if (keyboard.some((code) => code.includes(sliceValue))) {
      return true;
    }
  }
  return false;
};
// "초기 비밀번호 설정시 또는 비밀번호 초기화시 또는 비밀번호 변경일이 90일 지났을 때 노출되는 팝업
// - 설정할 비밀번호 입력

// 비밀번호 설정 규칙
// - 영문, 숫자, 특수문자 2가지 조합 후 10자리 ~ 20자리 이내
// - 패스워드 변경 주기 3개월 (90일)
// - 키보드 순서로 3번 이상 연속된 문자 입력 불가
// - 동일한 글자가 3번이상 중복 불가"
const checkPw = (pass: string) => {
  if (pass === "") return "";
  const num = pass.search(/[0-9]/g);
  const eng = pass.search(/[a-z]/gi);
  const spe = pass.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
  const messages = [];
  if (pass.length < 10 || pass.length > 20) {
    messages.push("10자리 ~ 20자리 이내로 입력해주세요.");
  }
  if (pass.search(/\s/) !== -1) {
    messages.push("비밀번호는 공백 없이 입력해주세요.");
  }
  if ((num < 0 && eng < 0) || (eng < 0 && spe < 0) || (spe < 0 && num < 0)) {
    messages.push("영문,숫자, 특수문자 중 2가지 이상을 혼합하여 입력해주세요.");
  }
  return messages;
};

export const checkDuplication = (pass: string) => {
  const duplicationMap = pass.split("").reduce((pre, cur) => {
    pre.set(cur, (pre.get(cur) || 0) + 1);
    return pre;
  }, new Map());
  const values = duplicationMap.values();
  for (let i = 0; i < duplicationMap.size; i += 1) {
    if (values.next().value >= 3) return true;
  }
  return false;
};
export const validateName = (str: string) => {
  const korReg = /^[가-힣]*$/;

  const isKor = str.match(korReg);

  if (isKor) {
    return true;
  }
  return false;
};
export const isNum = (e: string) => {
  const isNum = !e?.search(/[0-9]/g);
  return isNum;
};

export const checkDetailAddress = (e: string) => {
  if (e.length < 2) return "상세주소는 두글자 이상이어야 합니다.";
  return undefined;
};
export const changeIsoToKorDate = (value: string, format?: string) => {
  return moment(value).format(format || sharedConstants.date.format);
};
export const getKorOrderServiceType = (
  orderServiceTypes: OrderServiceTypes
) => {
  switch (orderServiceTypes) {
    case OrderServiceTypes.TIRE_REPAIR:
      return "타이어 장착";
    case OrderServiceTypes.TIRE_DELIVERY:
      return "타이어 배송";
    case OrderServiceTypes.BATTERY_RUSH:
      return "배터리 출동";
    case OrderServiceTypes.VEHICLE_WASH:
      return "세차권 구매";
    default:
      return "";
  }
};
